module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/icon-conscription.5b209abf.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/icon-conscription.png
// module id = 2839
// module chunks = 11